import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const directDebitRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/direct-debit',
  component: lazyRouteComponent(() => import('@/pages/direct-debit/direct-debit-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const detailDirectDebitRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/direct-debit/$id',
  component: lazyRouteComponent(() => import('@/pages/direct-debit/detail-direct-debit-page')),
});
